import { ConsentSettings } from '@/types/cookie-consent';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export const defaultConsent: ConsentSettings = {
  functionality_storage: 'granted',
  security_storage: 'granted',
  analytics_storage: 'denied',
  ad_storage: 'denied',
  personalization_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
};

export const updateGTMConsent = (settings: ConsentSettings) => {
  window.gtag?.('consent', 'update', {
    functionality_storage: settings.functionality_storage,
    security_storage: settings.security_storage,
    ad_storage: settings.ad_storage,
    analytics_storage: settings.analytics_storage,
    personalization_storage: settings.personalization_storage,
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });
};

export const initializeTracking = () => {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function (...args: unknown[]) {
    window.dataLayer.push(args);
  };
  // Set default consent
  window.gtag('consent', 'default', {
    functionality_storage: 'granted', // Necessary
    security_storage: 'granted', // Necessary
    ad_storage: 'denied',
    analytics_storage: 'denied',
    personalization_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });

  // GTM initialization
  const w = window;
  const d = document;
  const s = 'script';
  const l = 'dataLayer';
  const i = import.meta.env.VITE_GTM_ID;
  if (!i) {
    console.error(
      'GTM ID is not defined. Please check your environment variables.',
    );
    return;
  }

  w[l] = w[l] || [];
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  const f = d.getElementsByTagName(s)[0];
  const j = d.createElement(s);
  const dl = l != 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f?.parentNode?.insertBefore(j, f);
};
